var _defs, _g, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMc = function SvgMc(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.39 86.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:#fff;}.c{fill:#ff5f00;}.d{fill:#eb001b;}.e{fill:#f79e1b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 131.39,
    height: 86.9
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 48.37,
    y: 15.14,
    width: 34.66,
    height: 56.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M51.94,43.45a35.94,35.94,0,0,1,13.75-28.3,36,36,0,1,0,0,56.61A35.94,35.94,0,0,1,51.94,43.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M120.5,65.76V64.6H121v-.24h-1.19v.24h.47v1.16Zm2.31,0v-1.4h-.36l-.42,1-.42-1h-.36v1.4h.26V64.7l.39.91h.27l.39-.91v1.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M123.94,43.45a36,36,0,0,1-58.25,28.3,36,36,0,0,0,0-56.61,36,36,0,0,1,58.25,28.3Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMc);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzEuMzkgODYuOSI+PGRlZnM+PHN0eWxlPi5he29wYWNpdHk6MDt9LmJ7ZmlsbDojZmZmO30uY3tmaWxsOiNmZjVmMDA7fS5ke2ZpbGw6I2ViMDAxYjt9LmV7ZmlsbDojZjc5ZTFiO308L3N0eWxlPjwvZGVmcz48dGl0bGU+QXNzZXQgMTwvdGl0bGU+PGcgY2xhc3M9ImEiPjxyZWN0IGNsYXNzPSJiIiB3aWR0aD0iMTMxLjM5IiBoZWlnaHQ9Ijg2LjkiLz48L2c+PHJlY3QgY2xhc3M9ImMiIHg9IjQ4LjM3IiB5PSIxNS4xNCIgd2lkdGg9IjM0LjY2IiBoZWlnaHQ9IjU2LjYxIi8+PHBhdGggY2xhc3M9ImQiIGQ9Ik01MS45NCw0My40NWEzNS45NCwzNS45NCwwLDAsMSwxMy43NS0yOC4zLDM2LDM2LDAsMSwwLDAsNTYuNjFBMzUuOTQsMzUuOTQsMCwwLDEsNTEuOTQsNDMuNDVaIi8+PHBhdGggY2xhc3M9ImUiIGQ9Ik0xMjAuNSw2NS43NlY2NC42SDEyMXYtLjI0aC0xLjE5di4yNGguNDd2MS4xNlptMi4zMSwwdi0xLjRoLS4zNmwtLjQyLDEtLjQyLTFoLS4zNnYxLjRoLjI2VjY0LjdsLjM5LjkxaC4yN2wuMzktLjkxdjEuMDZaIi8+PHBhdGggY2xhc3M9ImUiIGQ9Ik0xMjMuOTQsNDMuNDVhMzYsMzYsMCwwLDEtNTguMjUsMjguMywzNiwzNiwwLDAsMCwwLTU2LjYxLDM2LDM2LDAsMCwxLDU4LjI1LDI4LjNaIi8+PC9zdmc+";